<template>
  <div>
    <GlobalInfoBar title="回收参数配置" content="配置信息由繁星平台帮助企业开通时配置" />
    <div>
      <div class="tabRound">
        <div :class="clickTab == 1 ? 'left' : 'right'" @click="getItme(1)">回收参数配置</div>
        <div :class="clickTab == 2 ? 'left' : 'right'" @click="getItme(2)">自售业务配置</div>
      </div>
    </div>
    <div class="content" v-if="config && clickTab == 2">
      <div class="step-title">
        <span>其他配置 </span>
      </div>
      <div class="flex">
        <span>送货上门：</span>
        <div class="ml-55 flex">
          <span>下单后</span>
          <div class="input_box" style="margin: 0 10px;">
            <el-input  :maxlength="5" v-model.trim="visitVavue" oninput="this.value=value.replace(/[^0-9]/g,'')"
              size="small"></el-input>
          </div>
          <span>小时未付款订单自动取消</span>
          <span class="textLink ml-20" @click="saveFoods">
           保存
          </span>
        </div>
      </div>
      <div class="flex">
        <span>到店自提：</span>
        <div class="ml-55 flex">
          <span>超出预约时间</span>
          <div class="input_box" style="margin: 0 10px;">
            <el-input  :maxlength="5" v-model.trim="pickupVavue" oninput="this.value=value.replace(/[^0-9]/g,'')"
              size="small"></el-input>
          </div>
          <span>小时未付款订单自动取消</span>
          <span class="textLink ml-20" @click="savePick">
            保存
          </span>
        </div>
      </div>
      <div class="step-title">
        <span>指定售出接单人 </span>
      </div>
      <div class="flex">
        <div class="flex">
          <span>当商品库存位置在公司时，需指定售出接单人，否则顾客下单无法及时派送</span>
          <span class="textLink ml-20" @click="saveSaleoutpople">
            添加
          </span>
        </div>
      </div>
      <div>
        <GlobalTable ref="GlobalTable" :columns="receiverColumns" :data="receiverDataList" :maxHeight="700"
          :isPagination="false">
          <el-table-column label="角色" slot="staffType" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.isMajor
                  ? "创建人"
                  : row.staffType == "01"
                    ? "子账号"
                    : row.staffType == "02"
                      ? "总监"
                      : row.staffType == "03"
                        ? "店长"
                        : "店员" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否关注公众号" slot="isSubscribe" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.isSubscribe ? '是' : '否' }}</span>
            </template>
          </el-table-column>
        </GlobalTable>
      </div>

    </div>
    <div class="content" v-if="config && clickTab == 1">
      <div class="step-title flex">
        <span>到期时间</span>
        <div class="ml-60" style="font-weight: 500">
          距离到期还剩
          <span style="color: red">{{ config.expireDay ? config.expireDay : 0 }}天</span>
        </div>
      </div>

      <div class="flex">
        <label class="label_width">截止日期：</label>
        <div class="ml-55">
          {{
            config.expireTime ? config.expireTime : "--"
          }}（到期将停用相关服务，请提前联系繁星商务人员）<span @click="DialogVisible = true" class="textLink">立即咨询</span>
        </div>
      </div>

      <div class="step-title">
        <span>基础配置</span>
      </div>

      <div class="flex">
        <label class="label_width">门店推荐方式：</label>
        <div class="ml-55">
          {{
            config.storeRecommendWay == "01"
            ? "优先按距离位置最近"
            : "优先按分享绑定关系"
          }}
        </div>
      </div>
      <div class="flex">
        <label class="label_width">回收方式配置：</label>
        <div class="ml-55">
          {{ config.configWay == "01" ? "仅到店回收" : "到店及上门回收" }}
        </div>
      </div>
      <div class="flex">
        <label class="label_width">C端展示方：</label>
        <div class="ml-55">{{ config.mallShow ? config.mallShow : "--" }}</div>
      </div>
      <div class="step-title">
        <span>短信配置</span>
      </div>
      <div class="flex">
        <label class="label_width">短信账号：</label>
        <div class="ml-55">
          {{ config.smsAccount ? config.smsAccount : "--" }}
        </div>
        <!-- (创蓝云智) -->
      </div>
      <div class="flex">
        <label class="label_width">剩余条数：</label>
        <div class="ml-55">
          {{ config.smsCount ? config.smsCount : 0 }}条 登录查询发送明细
          <a style="margin-left: 20px" class="textLink" target="_blank"
            href="https://www.chuanglan.com/control/login">https://www.chuanglan.com/control/login</a>
        </div>
      </div>
      <div class="step-title">
        <span>其他配置 </span>
      </div>

      <div class="flex">
        <label class="label_width">默认营业时间：</label>
        <div class="ml-55">
          {{ config.defaultBusinessHours || "--" }}
          <span class="textLink ml-20" @click="upDate">修改</span>
          <span class="ml-20">初始化时间按默认营业时间显示，可以按单店独立设置</span>
          <span @click="tolink" class="textLink ml-20">前往设置</span>
        </div>
      </div>
      <div class="flex">
        <label class="label_width">上门起收金额：</label>
        <div class="ml-55 flex">
          <div class="input_box">
            <el-input v-model.trim="input" :disabled="inputFlag" oninput="this.value=value.replace(/[^0-9]/g,'')"
              size="small"></el-input>
          </div>
          <span class="textLink ml-20" @click="saveConfig">{{
            inputFlag ? "修改" : "保存"
          }}</span>
        </div>
      </div>
    </div>
    <el-dialog title="修改营业时间" :visible.sync="delDialogVisible" :close-on-click-modal="false" width="400px"
      @closed="delDialogVisible = false">
      <div class="flex">
        <div style="margin-right: 20px">
          <el-time-select placeholder="起始时间" v-model="startTime" :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
              }">
          </el-time-select>
        </div>
        <div>
          <el-time-select placeholder="结束时间" v-model="endTime" :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                minTime: startTime,
              }">
          </el-time-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="delDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="delConfirmDialog">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 指定售出接单人 -->
    <el-dialog title="指定售出接单人" :visible.sync="sureExDialog" :close-on-click-modal="false" width="800px">
      <div class="exStitle">说明：设置后用于商品库存位置在公司总部时，顾客选择送货上门时，向指定接单人推送消息。</div>
      <GlobalTable ref="GlobalTable" :columns="urtableColumns" :data="urDataList" :maxHeight="700" :isPagination="false"
        :isSelection="true" @handleSelect="handleSelect">
        <el-table-column label="角色" slot="staffType" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isMajor
                  ? "创建人"
                  : row.staffType == "01"
                    ? "子账号"
                    : row.staffType == "02"
                      ? "总监"
                      : row.staffType == "03"
                        ? "店长"
                        : "店员" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否关注公众号" slot="isSubscribe" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isSubscribe ? '是' : '否' }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="sureExDialog = false">关 闭</el-button>
        <el-button size="small" type="primary" @click.native="exportSure">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="业务咨询" :visible.sync="DialogVisible" :close-on-click-modal="false" width="400px"
      @closed="DialogVisible = false">
      <div style="
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-bottom: 20px;
        ">
        <img style="width: 200px; height: 200px" :src="config.platformWechatQrCode" alt="" />
        <p style="font-size: 16px; margin-bottom: 5px">请扫码添加微信咨询</p>
        <div>电话：{{ config.platformServicePhone }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { http } from "@/utils/request/newIndex";
export default {
  name: "merchant-add",
  data() {
    return {
      sureExDialog: false,
      visitVavue: 72,//送货上门
      pickupVavue: 24,//到店自提
      clickTab: "1",
      option: [],
      DialogVisible: false,
      config: {},
      delDialogVisible: false,
      startTime: "",
      endTime: "",
      input: 1,
      inputFlag: true,
      urtableColumns: [
        { label: "指定接单人", prop: "staffName" },
        { label: "联系电话", prop: "staffMobile" },
        { slotName: "staffType" },
        { slotName: "isSubscribe" },
      ],
      urDataList: [],
      receiverColumns: [
        { label: "售出接单人", prop: "staffName" },
        { label: "联系电话", prop: "staffMobile" },
        { slotName: "staffType" },
        { slotName: "isSubscribe" },
      ],
      receiverDataList: [],
      reorderData: [],
      formData: {
        id: "",
        value: "",
        type: "", //01:修改营业时间 02:修改起收金额
      },
    };
  },
  mounted() {
    this.getMasterStaffList()
    this.getConfig();
  },
  methods: {
    //选择接单人
    handleSelect(data) {
      console.log(data);
      this.reorderData = data
    },
    //获取接单人设置列表
    getMasterStaffList() {
      http.getMasterStaffList().then(res => {
        if (res.code === 1) {
          console.log(res);
          this.urDataList = res.data
        }
      })
    },
    //
    saveSaleoutpople() {
      this.sureExDialog = true
    },
    //送货上门时间修改
    saveFoods() {
      if (this.visitVavue < 2) {
        this.$message.error('自动取消时间必须大于1小时！');
        return
      }
      this.formData.type = '03'
      this.formData.value = this.visitVavue
      _api.updateConfig(this.formData).then((res) => {
        this.getConfig();
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.sureExDialog = false
      });
    },
    //到店自提时间修改
    savePick() {
      if (this.pickupVavue < 2) {
        this.$message.error('自动取消时间必须大于1小时！');
        return
      }
      this.formData.type = '04'
      this.formData.value = this.pickupVavue
      _api.updateConfig(this.formData).then((res) => {
        this.getConfig();
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.sureExDialog = false
      });
    },
    //确认修改
    exportSure() {
      if (this.reorderData.length > 1) {
        this.$message.error('指定售出接单人只能是一个！');
        return
      }
      if (this.reorderData.length === 0) {
        this.$message.error('请选择指定售出接单人！');
        return
      }
      this.formData.type = '05'
      this.formData.value = this.reorderData[0].staffId
      _api.updateConfig(this.formData).then((res) => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.getConfig();
        this.sureExDialog = false
      });

    },
    getConfig() {
      this.receiverDataList = []
      _api.parametersGetConfig().then((res) => {
        console.log(res);
        this.config = res.data;
        if (res.data.productReceiveStaff) {
          this.receiverDataList.push(res.data.productReceiveStaff)
        }
        this.formData.id = res.data.id;
        this.input = res.data.initialAmountReceived || 1;
        this.visitVavue = res.data.goHomeAfterHourCancel || 72
        this.pickupVavue = res.data.goStoreTimeoutHourCancel || 24
      });
    },
    getItme(index) {
      this.clickTab = index
      this.getConfig();
    },
    tolink() {
      let routeData = this.$router.resolve({
        path: "/OnlinreyService/OnlineStoreManagement",
      });
      window.open(routeData.href, "_blank");
    },
    upDate() {
      this.formData.type = "01";
      this.delDialogVisible = true;
    },
    delConfirmDialog() {
      if (!this.startTime || !this.endTime) {
        this.$message.error("请选择营业时间");
        return;
      }
      this.formData.value = this.startTime + "~" + this.endTime;
      _api.updateConfig(this.formData).then((res) => {
        this.getConfig();
        this.delDialogVisible = false;
      });
    },

    // 保存金额
    saveConfig() {
      this.inputFlag = !this.inputFlag;
      if (this.inputFlag) {
        if (this.input == "" || this.input == "0") {
          this.input = 1;
        }
        this.formData.value = this.input;
        this.formData.type = "02";
        _api.updateConfig(this.formData).then((res) => {
          this.getConfig();
          this.delDialogVisible = false;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.exStitle {
  margin-bottom: 15px;
  color: #ff8080;
  font-size: 14px;
}

/deep/ .el-select {
  width: 100%;
}

.title_c {
  font-size: 14px !important;
  color: #989898 !important;
  font-weight: 500 !important;
  margin-left: 20px !important;
}

/deep/.global-chunk_header_filter {
  padding: 0;
}

.flex {
  display: flex;
  align-items: center;
}

.mb-20 {
  margin-bottom: 20px;
}

.ml-20 {
  margin-left: 20px;
}

.label_width {
  width: 115px;
  margin-left: 15px;
  text-align: right;
}

.ml-55 {
  margin-left: 55px;
}

.ml-60 {
  margin-left: 60px;
}

.content {
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  box-sizing: border-box;

  >div {
    margin-bottom: 30px;
  }
}

.tabRound {
  cursor: pointer;
  margin-bottom: 20px;
  width: 280px;
  height: 32px;
  background: #F9FBFD;
  border: 1px solid #C1D1FF;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 16px;
  display: flex;

  .left {
    text-align: center;
    color: white;
    width: 50%;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 34px;
    height: 32px;
    background: #0981FF;
    border-radius: 16px;
  }

  .right {
    text-align: center;
    color: #333;
    width: 50%;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 34px;
    height: 32px;
    border-radius: 16px;
  }
}

.step-title {
  color: #333;
  margin-bottom: 10px;
  padding-left: 6px;
  border-left: 8px solid #0981ff;
  border-radius: 1.5px;
  font-weight: bold;

  >span {
    width: 100px;
  }
}

.textLink {
  color: #0981ff;
  text-decoration: underline;
  cursor: pointer;
}

.input_box {
  width: 80px;
}

/deep/ .input_box .el-input--small .el-input__inner {
  text-align: center;
}
</style>
